import { render, staticRenderFns } from "./TrainManage.vue?vue&type=template&id=0bfb69c1&scoped=true"
import script from "./TrainManage.vue?vue&type=script&lang=js"
export * from "./TrainManage.vue?vue&type=script&lang=js"
import style0 from "./TrainManage.vue?vue&type=style&index=0&id=0bfb69c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb69c1",
  null
  
)

export default component.exports